import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const interviewRoundsGet = (applicantId, includeInactive = false) =>
	axios.get(`${apiUrl}ats/applicants/${applicantId}/interviews?includeInactive=${!!includeInactive}`);

export const interviewRoundGetById = (applicantId, roundId) =>
	axios.get(`${apiUrl}ats/applicants/${applicantId}/interviews/${roundId}`);

export const interviewRoundCreate = (applicantId, data) =>
	axios.post(`${apiUrl}ats/applicants/${applicantId}/interviews`, data);

export const interviewRoundUpdate = (applicantId, roundId, data) =>
	axios.put(`${apiUrl}ats/applicants/${applicantId}/interviews/${roundId}`, data);

export const interviewRoundComplete = (applicantId, roundId, data) =>
	axios.post(`${apiUrl}ats/applicants/${applicantId}/interviews/${roundId}/complete`, data);

export const interviewRoundGenerate = (applicantId, data = {}) =>
	axios.post(`${apiUrl}ats/applicants/${applicantId}/interviews/generate`, data);

export const interviewRoundEvaluate = (applicantId, roundId) =>
	axios.post(`${apiUrl}ats/applicants/${applicantId}/interviews/${roundId}/evaluate`, {});

export const interviewRoundDelete = (applicantId, roundId) =>
	axios.delete(`${apiUrl}ats/applicants/${applicantId}/interviews/${roundId}`);
